export class XmlParseError extends Error {
    constructor(message: string) {
        super(message);
        this.name = "XmlParseError";
    }
}

export function parseXmlDocument(source: string): Document {
    const doc = new DOMParser().parseFromString(source, "application/xml");
    const error = doc.getElementsByTagName("parsererror")[0];

    if (error) throw new XmlParseError(error.textContent?.trim() || "Malformed XML");

    return doc;
}

export function children(element: Element | null, name: string): Element[] {
    if (!element) return [];

    return Array.from(element.children).filter((c) => c.localName === name);
}

export function child(element: Element | null, ...path: string[]): Element | null {
    return path.reduce<Element | null>(
        (current, name) => children(current, name)[0] ?? null,
        element,
    );
}

export function text(element: Element | null, ...path: string[]): string | null {
    const value = child(element, ...path)?.textContent?.trim();

    return value ? value : null;
}

export function amount(element: Element | null, ...path: string[]): number | null {
    const value = text(element, ...path);
    if (value === null) return null;

    const parsed = Number(value);

    return Number.isFinite(parsed) ? parsed : null;
}

export function joinNonEmpty(parts: (string | null)[], separator = " "): string | null {
    const joined = parts.filter(Boolean).join(separator);

    return joined || null;
}
